import { render, staticRenderFns } from "./lifeExperienceDialog.vue?vue&type=template&id=615aecf4&scoped=true"
import script from "./lifeExperienceDialog.vue?vue&type=script&lang=js"
export * from "./lifeExperienceDialog.vue?vue&type=script&lang=js"
import style0 from "./lifeExperienceDialog.vue?vue&type=style&index=0&id=615aecf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615aecf4",
  null
  
)

export default component.exports